<template>
    <div :class=" isMain ? 'mainConfigResumeHeader' : 'configResumeHeader'">
        <img :class="{ active: !isMain }" :src="icon" :alt="resumeData.model" @click="$emit('click', isMain)">
        <p class="configResumeHeader-label"><b>Resumo</b> da configuração:</p>
        <p class="h2"> {{ resumeData.model }} </p>
        <p class="configResumeHeader-version"> {{ resumeData.configSelected.version.designation }} </p>
        <div v-if="!isMain" class="configResumeHeader-btns">
            <button class="btn-primary" @click="openFormPropose">Proposta</button>
            <button class="btn-primary" @click="openFormMTD">Test-Drive</button>
            <router-link  class="btn-primary-rightIcon" :to="nextRoute"> {{ gama }} Nova Configuração</router-link>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import {modalForms} from '../../../mixins/modalForms'
    import { navigatonFunctions } from '../../../mixins/navigatonFunctions';

    export default {
        name: 'ConfigResumeHeader',
        mixins: [modalForms, navigatonFunctions],
        props:{
            isMain:{type: Boolean, default: false},
        },
        data(){return{
            icon: require('@/assets/img/chevFlatDown.webp'),
            rotateImg: false,
        }},
        computed:{
            ...mapState(['resumeData']),
        },
        methods:{
            getNextInfo(){
                this.$emit('change-info', false);
            }
        }
    }
</script>
<style lang="scss" scoped>
    .configResumeHeader,
    .mainConfigResumeHeader{
        display: flex;
        flex-direction: column;
        align-items: center;

        img.active{ transform: rotate(180deg); }

        &-label{
            margin: .5rem 0 .6rem;
            color: $grayDarkCol;
            b{ font-family: $medium;}
        }

        & > .h2{
            @include mixin_textContent(.875rem ,.875rem, $medium, $grayDarkCol);
            margin-bottom: .5rem;
        }

        &-version{
            @include mixin_textContent(.75rem, .75rem , $regular, $grayLightCol);
        }

        &-btns{
            width: 100%;
            margin-top: 1.5rem;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            & > *{
                flex-basis: calc(50% - .5rem);
                padding: unset;
            }
        }
        .btn-primary-rightIcon {
            display: none;
        }
    }

    .configResumeHeader{
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100vw;
        background-color: $whiteCol;

        @include defaultPadding(mobile, 0, 2rem);
        z-index: 33;
    }

    .mainConfigResumeHeader{
        & > .h2{
            margin-top: .9rem;
            @include mixin_textContent_desktop(2rem ,1.5rem);
        }

        & > .configResumeHeader-version{
            margin: .375rem 0 2.5rem;
            @include mixin_textContent_desktop(1.125rem ,1.125rem);
        }
    }

    @include respond-to(large){
        .configResumeHeader{
            &-label{ font-size: 1.125rem;}
            &-version{ font-size: 1.375rem; color: $grayDarkCol;}
        }

        .mainConfigResumeHeader{
            align-items: flex-start;
            & > :first-child{display: none;}
        }
    }
</style>
